<sh-control *ngIf="control" [control]="this">
  <!-- TODO: Only the higher versions of Syncfusion have TextArea component -->
  <textarea
    [formControl]="control"
    [placeholder]="placeholder"
    [id]="formControlName"
    [attr.name]="formControlName"
  ></textarea>
</sh-control>
